import { useState } from 'react'

import { Logo } from '@twistopayments/design-system/components/atoms/logo'

import type { SectionsFooterComponent } from '@twisto/api-cms'

import { APRBlock, LinkList } from 'homepage/components/molecules'

import { DesktopGroupedColumns } from './desktop-grouped-columns'
import * as styles from './footer.styles'
import { MobileGroupedColumns } from './mobile-grouped-columns'
import { SocialIcons } from './social-icons'

export const Footer = ({
  socialIcons,
  columns,
  widget,
  copyrightLinks,
  copyrightText,
  apr,
}: SectionsFooterComponent) => {
  const [activeLists, setActiveLists] = useState<Array<string | number>>([])

  const toggleList = (id: string | number) => {
    setActiveLists((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    )
  }

  const groupedColumns = columns?.reduce(
    (acc, column) => {
      if (column.noWrap && acc.length > 0) {
        acc[acc.length - 1].push(column)
      } else {
        acc.push([column])
      }

      return acc
    },
    [] as Array<Array<(typeof columns)[0]>>
  )

  return (
    <footer css={styles.footer}>
      <div css={styles.container}>
        <div css={styles.social}>
          <Logo css={styles.logo} size="large" />
          {socialIcons && <SocialIcons icons={socialIcons} />}
        </div>

        <MobileGroupedColumns
          activeLists={activeLists}
          columns={columns}
          toggleList={toggleList}
          widget={widget}
        />

        <DesktopGroupedColumns
          groupedColumns={groupedColumns}
          widget={widget}
        />

        <div css={styles.copyright}>
          <p css={styles.copyrightText}>{copyrightText}</p>
          <LinkList hasUnderline isBold links={copyrightLinks} />
        </div>

        {apr && <APRBlock {...apr} />}
      </div>
    </footer>
  )
}
